import FormJaivana from 'dashboard_jaivana_v1';

/**
 *
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */

class CustomDiferenciaDeInventario extends FormJaivana.form
{
    constructor(props)
    {
        super(props);

        this.initForm = this.initForm.bind(this);
        this.successTraerDatosFicha = this.successTraerDatosFicha.bind(this);
        this.devolverReformulacion  = this.devolverReformulacion.bind(this);
        //this.succesDevolverReform   = this.succesDevolverReform.bind(this);
        this.verFormula = this.verFormula.bind(this);
        this.successVerFormula = this.successVerFormula.bind(this);
        this.gridOptionsVerFormula = Object.assign({}, this.gridOptions);
    }

    initForm(){
        console.log('CustomDiferenciaDeInventario @Version: 1.01.0054, @Author: Juan David Nieto; @updateBy Sebastian Rios Echverri');

        //produccion_fichas-iddatos
        let datos = {
            datos:{
                value: this.props.data.id_ficha,    // body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consultar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTraerDatosFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = 'servicio_diferencia_inventario_traer_datos_ficha'; // nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successTraerDatosFicha,
                error: this.error_,
                general: this.generalFormat
            });*/


        this.getField('btnDevolveraRefor').setClick(this.devolverReformulacion);
        this.getField('btn_verformula').setClick(this.verFormula);
    }

    verFormula(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerFormula,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.data;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }
    
    successTraerDatosFicha(data){
        //console.log("Datos de la ficha",data);
        let datosFicha = [];
        if(data.estado_p === 200 && data.data !== undefined && data.data.length > 0){
            this.getField('lista_datos_ficha').setVisible(true);
            datosFicha.push(data.data[0]);
            this.getField('lista_datos_ficha').setItemsFichas(datosFicha);
        } else{
            this.getField('lista_datos_ficha').setVisible(false);
        }
    }

    devolverReformulacion(){
        let datos = {
            datos:{
                proceso_id: this.props.data.proceso_id,    // body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
                actividad_configuracion_id: this.props.data.actividad_configuracion_id,
                actividad_id: this.props.data.actividad_id,
                produccion_fichas_id: this.props.data.id_ficha,
                observaciones_cancelacion_alistamiento: this.getField('observaciones_cancelacion_alistamiento').getValue(),
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-diferenciainv', operacion: 'devolver', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successCloseEstage,
            error: this.error_,
            general: this.generalFormatPmv
        });
        // aprobacion_cancelacion_alistamiento-devolver
        /*this.generalFormat.nombre_accion = 'servicio_aprobacion_cancelac_devo_alistamien'; // nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'PUT',
                body: body,
                success: this.successCloseEstage,
                error: this.error_,
                general: this.generalFormat
            });*/

    }

/**
 *     succesDevolverReform(data){
        if(data.estado_p === 200){
            console.log("debe cerrar el formulario y recargar los servicios de la letra P");
            
        }
    }
 */
}

FormJaivana.addController("prod-diferenciainv",CustomDiferenciaDeInventario);

export default CustomDiferenciaDeInventario;